'use client';

import { Theme } from '@/lib/util/theme';
import { HTMLProps } from '@/lib/util/types';
import { useTheme } from '@/providers/theme-provider';

// Initial code to set theme based on user preference
const initialSetTheme = `
(function() {
  const deviceTheme = (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
  document.body?.setAttribute('data-theme', deviceTheme);
})();
`;

export type ThemedBodyProps = {
  savedTheme?: Theme;
} & HTMLProps<HTMLBodyElement>;

export default function ThemedBody({ children, savedTheme, ...props }: ThemedBodyProps) {
  const { theme } = useTheme();

  return (
    // Need to suppress hydration warnings as we dynamically change the data-theme attribute on page
    // load to match the user preferences. This is necessary to avoid FOUC. This only affects this
    // very body element, not any of its children.
    <body {...props} data-theme={theme} suppressHydrationWarning>
      {children}

      {/* Script to set the initial themeing */}
      {!savedTheme && <script dangerouslySetInnerHTML={{ __html: initialSetTheme }} />}
    </body>
  );
}
